import { render, staticRenderFns } from "./RiskIndexChart.vue?vue&type=template&id=2a87a908&scoped=true"
import script from "./RiskIndexChart.vue?vue&type=script&lang=js"
export * from "./RiskIndexChart.vue?vue&type=script&lang=js"
import style0 from "./RiskIndexChart.vue?vue&type=style&index=0&id=2a87a908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a87a908",
  null
  
)

export default component.exports